import { useResumeStore } from "@/client/stores/resume";
import {
  useFindResumeAnalysis,
  useGenerateResumeAnalysis,
} from "@/client/services/resume-analysis";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

export function useGenerateAnalyze() {
  const [hasAttemptedGeneration, setHasAttemptedGeneration] = useState(false);
  const [generationError, setGenerationError] = useState<string | null>(null);
  const queryClient = useQueryClient();

  const resumeId = useResumeStore((state) => state.resume.id);
  const setPendingAnalyze = useResumeStore((state) => state.setPendingAnalyze);

  const { data: analysisData, isLoading } = useFindResumeAnalysis(resumeId);
  const { generateAnalysis, loading: isGenerating } = useGenerateResumeAnalysis();

  const handleGenerateAnalysis = async () => {
    if (resumeId) {
      console.log("ANALYZING RESUME::", resumeId);
      try {
        await queryClient.invalidateQueries({ queryKey: ["resume-analysis", { id: resumeId }] });
        setGenerationError(null);
        await generateAnalysis({ id: resumeId });
        setHasAttemptedGeneration(true);
      } catch (error) {
        setGenerationError(error instanceof Error ? error.message : "Failed to generate analysis");
        setHasAttemptedGeneration(true);
      } finally {
        setPendingAnalyze(false);
      }
    }
  };

  const handleRetryGeneration = async () => {
    setHasAttemptedGeneration(false);
    setGenerationError(null);
    await handleGenerateAnalysis();
  };

  return {
    generate: handleGenerateAnalysis,
    retry: handleRetryGeneration,
    hasAttemptedGeneration,
    generationError,
    isLoading,
    isGenerating,
    analysisData,
  };
}
